export const projects = [
  {
    id: 1,
    title: 'Concept Learning Model',
    description:
      'Developed a cognitive model for concept learning using the Clarion architecture, explaining human concept processing and categorization by integrating sensory and linguistic representations through an associative merging mechanism.',
    tech: 'Python • PyClarion • Cognitive Modeling • SNN',
    image: '/img/drm.png',
    github: 'https://github.com/kumkum1/conceptLearningModel',
    live: 'https://example.com'
  },
  {
    id: 2,
    image: '/img/recipe-search-software.png',
    title: 'Recipe Search Software',
    tech: 'Java • REST APIs • Collaborative Development • User Interface Design',
    description:
      'Developed a recipe search application in Java with a collaborative team, integrating APIs and user-driven contributions to boost daily active users by 40%.',
    github: 'https://github.com/kumkum1/Recipe_Search',
    live: 'https://example.com'
  },
  {
    id: 3,
    image: '/img/image-filter-server.png',
    title: 'Image Filter Server',
    tech: 'C++ • Web Development • Image Processing • Server Architecture',
    description:
      'Built a C++ server application enabling users to upload photos and apply filters via a user-friendly web interface, optimizing the image processing workflow for enhanced performance.',
    github: 'https://github.com/example/image-filter-server',
    live: 'https://example.com'
  },
  {
    id: 4,
    image: '/img/irt-model.png',
    title: 'Item Response Theory (IRT) Model',
    tech: 'Python • Machine Learning • Statistical Analysis',
    description:
      'Enhanced an IRT model for individualized learning assessments, achieving a 90% improvement in accuracy by optimizing model parameters and algorithms.',
    github: 'https://github.com/example/irt-model',
    live: 'https://example.com'
  },
  {
    id: 5,
    image: '/img/f1-predictive-model.png',
    title: 'F1 Predictive Model',
    tech: 'Python • RNN • LSTM • Machine Learning • Data Analysis',
    description:
      'Developed a machine learning model using RNN and LSTM to predict F1 driver lap times and positions, achieving 80% accuracy and predictions within 3 seconds of target lap times.',
    github: 'https://github.com/kumkum1/F1_predictive_model',
    live: 'https://example.com'
  },
  {
    id: 6,
    image: '/img/drm.png',
    title: 'DRM Sleep Simulation',
    tech: 'Python • LSTM • Neural Networks • Cognitive Science • Sleep Research',
    description:
      'Designed and implemented a Python-based simulation model utilizing LSTM neural networks to analyze the effects of sleep on DRM false memory formation, successfully replicating empirical study findings.',
    github: 'https://github.com/kumkum1/DRM-memory-simulation',
    live: 'https://example.com'
  },
  {
    id: 7,
    title: 'Contacts Tracking App',
    description:
      'Designed and developed a contact lens tracking app using SwiftUI, optimizing UI rendering and overall app usability.',
    tech: 'Swift • SwiftUI • App Development',
    image: '/img/logo-light.png',
    github: 'https://github.com/kumkum1/LensTrack',
    live: 'https://example.com'
  },
  {
    id: 8,
    title: 'Research Code',
    description:
      'A collection of research-focused code and experiments spanning cognitive science and AI-oriented modeling workflows.',
    tech: 'Python • Research • Cognitive Science • Data Modeling',
    image: '/img/uoft.png',
    github: 'https://github.com/kumkum1/research',
    live: 'https://example.com'
  }
];
